import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "testimonials-grid" }

import { motion } from "motion-v"
import BaseSection from "@/views/sections/BaseSection.vue"
import GradientTitle from "@/components/GradientTitle.vue"
import CodeEditor from "@/components/CodeEditor.vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'TestimonialsSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSection, { "background-style": "light" }, {
    default: _withCtx(() => [
      _createVNode(_unref(motion).div, {
        class: "testimonials-header",
        initial: { opacity: 0, y: 30 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.6 },
        inViewOptions: { once: true }
      }, {
        default: _withCtx(() => [
          _createVNode(GradientTitle, {
            text: "Was Kunden sagen",
            tag: "h2"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "testimonials-subtitle" }, "Feedback von langjährigen Partnern", -1))
        ]),
        _: 1,
        __: [0]
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(motion).div, {
          class: "testimonial-card",
          initial: { opacity: 0, x: -50 },
          whileInView: { opacity: 1, x: 0 },
          transition: { delay: 0.2, duration: 0.7 },
          inViewOptions: { once: true }
        }, {
          default: _withCtx(() => [
            _createVNode(CodeEditor, {
              filename: "testimonial_omergy.js",
              "total-lines": 15
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "keyword" }, "const"),
                  _createTextVNode(),
                  _createElementVNode("span", { class: "variable" }, "testimonial"),
                  _createTextVNode(" = {")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "company"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "string" }, "\"OMERGY GmbH\""),
                  _createTextVNode(",")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "author"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "string" }, "\"Alexander Ardissone\""),
                  _createTextVNode(",")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "position"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "string" }, "\"Head of Development\""),
                  _createTextVNode(",")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "rating"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "number" }, "5"),
                  _createTextVNode(",")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "message"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "string" }, "`Ariel war über fünf Jahre fest im Entwicklerteam")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "und unterstützte uns danach als Freelancer. Er ist ein")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "zuverlässiger Profi mit tiefen Kenntnissen in PHP/Laravel, ")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "Vue.js, Infrastruktur, Kubernetes und AWS. Er erfasst Themen")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "schnell, denkt bei komplexen Aufgaben mit und liefert ")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "pragmatische, saubere Lösungen. Dabei arbeitet er")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "eigenständig, gründlich und sehr effizient. Seine offene")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "und zuvorkommende Art macht die Zusammenarbeit besonders")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "angenehm. Wir freuen uns auf weitere Projekte mit ihm!`")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, "};", -1)
              ])),
              _: 1,
              __: [1]
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(motion).div, {
          class: "testimonial-card",
          initial: { opacity: 0, x: 50 },
          whileInView: { opacity: 1, x: 0 },
          transition: { delay: 0.4, duration: 0.7 },
          inViewOptions: { once: true }
        }, {
          default: _withCtx(() => [
            _createVNode(CodeEditor, {
              filename: "testimonial_sopamo.js",
              "total-lines": 10
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "keyword" }, "const"),
                  _createTextVNode(),
                  _createElementVNode("span", { class: "variable" }, "testimonial"),
                  _createTextVNode(" = {")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "company"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "string" }, "\"Sopamo GmbH\""),
                  _createTextVNode(",")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "author"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "string" }, "\"David Paul Mohr\""),
                  _createTextVNode(",")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "position"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "string" }, "\"Geschäftsführer\""),
                  _createTextVNode(",")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "rating"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "number" }, "5"),
                  _createTextVNode(",")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "property" }, "message"),
                  _createTextVNode(": "),
                  _createElementVNode("span", { class: "string" }, "`Ariel ist super engagiert und kennt sich top im")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "Laravel und Vue.js Umfeld aus. Sehr zuverlässig und super")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "Kommunikation. Ich würde sehr gerne wieder mit ihm zusammen")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, [
                  _createElementVNode("span", { class: "string" }, "arbeiten :)`")
                ], -1),
                _createElementVNode("div", { class: "code-line" }, "};", -1)
              ])),
              _: 1,
              __: [2]
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})